<template>
  <div>
    <div class="all-div">
      <el-menu :default-active="actIndex" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
        :collapse="isCollapse" background-color="#374151" text-color="#fff">
        <h3>{{ getTitle() }}</h3>
        <el-menu-item @click="clickMenu(item, '')" v-for="item in noChildren" :key="item.path" :index="item.path">
          <i :class="`el-icon-${item.icon}`"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>

        <el-submenu v-for="item in hasChildren" :key="item.label" :index="item.label">
          <template slot="title">
            <i :class="`el-icon-${item.icon}`"></i>
            <span slot="title">{{ item.label }}</span>
          </template>
          <el-menu-item-group v-for="subItem in item.children" :key="subItem.path">
            <el-menu-item @click="clickMenu(subItem, item)" :index="subItem.path">{{ subItem.label }}</el-menu-item>
          </el-menu-item-group>

        </el-submenu>
      </el-menu>

    </div>
  </div>
</template>



<script>
import { isMobile } from '../utils/device'

export default {
  name: "CommonAside",

  data() {
    return {
      menuData: [],
      level: JSON.parse(localStorage.getItem('userInfo')).level,
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    clickMenu(item, faitem) {
      if (isMobile()) {
        this.$store.commit('collapseMenu')
      }
      if (this.$route.path !== item.path && !(this.$route.path === '/home' && (item.path === '/'))) {
        this.$router.push(item.path)
      }
    },
    getTitle(){
      if (localStorage.getItem("lang")==='US'){
        if (this.$store.state.tab.isCollapse){
          return 'backend'
        }else
          return "Agent backend"
      }else {
        if (this.$store.state.tab.isCollapse){
          return '后台'
        }else
          return "代理后台管理"
      }
    },
    label_width(){
      if(localStorage.getItem('lang')==='US'){
        return '350px'
      }
      return '180px'
    }
  },
  computed: {
    //没有子菜单
    noChildren() {
      var menu = []
      for (let i = 0; i < this.menuData.length; i++) {
        var item = this.menuData[i]
        if (!item.children && item.show) {
          menu.push(item)
        }
      }
      return menu
    },
    //有子菜单
    hasChildren() {
      var menu = []
      for (let i = 0; i < this.menuData.length; i++) {
        var item = this.menuData[i]
        if (item.children && item.show) {
          menu.push(item)
        }
      }
      return menu
    },
    isCollapse() {
      return this.$store.state.tab.isCollapse
    },
    actIndex() {
      return this.$route.path
      }
  },
  created() {
    this.$store.commit("updateMenu", [this.noChildren])

    this.$i18n.locale = localStorage.getItem("lang")
    this.menuData = [
      // {
      //   path: '/',
      //   name: 'home',
      //   label: '首页',
      //   icon: 's-home',
      //   url: 'Home/Home',
      //   show: true
      // },
      {
        path: '/updatePassword',
        name: 'updatePassword',
        label: this.$t('msg.Change_Password'),
        icon: 's-check',
        url: 'updatePassword',
        show: true
      },
      {
        path: '/updatePrivateAside',
        name: 'updatePrivateAside',
        label: this.$t('msg.Change_personal_2_Password'),
        icon: 'edit',
        url: 'updatePrivateAside',
        show: true
      },
      {
        path: '/accountList',
        name: 'accountList',
        label: this.$t('msg.user_management'),
        icon: 'user-solid',
        url: 'accountList',
        show: true
      },
      {
        path: '/editUser',
        name: 'editUser',
        label: this.$t('msg.Edit_User'),
        icon: 's-home',
        url: 'editUser',
        show: false
      },
      {
        path: '/editProxy',
        name: 'editProxy',
        label: this.$t('msg.Edit_agent'),
        icon: 's-home',
        url: 'editProxy',
        show: false
      },
      {
        path: '/setScore',
        name: 'setScore',
        label: this.$t('msg.Set_score1'),
        icon: 's-home',
        url: 'setScore',
        show: false
      },
      {
        path: '/setScoreLog',
        name: 'setScoreLog',
        label: this.$t('msg.score_log'),
        icon: 's-order',
        url: 'setScoreLog',
        show: true
      },
      {
        path: '/queryReport',
        name: 'queryReport',
        label: this.$t('msg.report'),
        icon: 's-home',
        url: 'queryReport',
        show: false
      },
      {
        path: '/allQueryReport',
        name: 'allQueryReport',
        label: this.$t('msg.General_ledger_audit'),
        icon: 's-home',
        url: 'allQueryReport',
        show: false
      },
      {
        path: '/userSearch',
        name: 'userSearch',
        label: this.$t('msg.Search_Account'),
        icon: 'zoom-in',
        url: 'userSearch',
        show: true
      },
      {
        path: '/bonusLog',
        name: 'bonusLog',
        label: this.$t('msg.Bonus_log'),
        icon: 'coin',
        url: 'bonusLog',
        show: false // 已屏蔽，代码保留在 src/views/_disabled/BonusLog.vue
      },
      {
        path: '/subAccount',
        name: 'subAccount',
        label: this.$t('msg.Sub_account_management'),
        icon: 'coordinate',
        url: 'subAccount',
        show: false // 已屏蔽，代码保留在 src/views/_disabled/SubAccount.vue
      },
      {
        path: '/updateSubProxy',
        name: 'updateSubProxy',
        label: this.$t('msg.Modify_subaccount_permissions'),
        icon: 'coordinate',
        url: 'updateSubProxy',
        show: false // 已屏蔽，代码保留在 src/views/_disabled/UpdateSubProxy.vue
      },
      {
        path: '/adminUpdatePwd',
        name: 'adminUpdatePwd',
        label: '修改代理密码',
        icon: 'coordinate',
        url: 'adminUpdatePwd',
        show: false
      },

    ]
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', '')
  },
}
</script>

<style lang="less">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.all-div {
  height: 100vh;
  background-color: #374151
}
.el-menu {
  border-right: none;
  height: 100vh;
  h3 {
    color: #fff;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonAside.vue